import { useState } from 'react';

interface Props {
  onCopyEmail: () => Promise<boolean>;
  onDownloadPdf: () => void;
  onDownloadJson: () => void;
  disabled?: boolean;
}

export function ExportBar({ onCopyEmail, onDownloadPdf, onDownloadJson, disabled }: Props) {
  const [emailToast, setEmailToast] = useState<string | null>(null);

  async function copyEmail() {
    const ok = await onCopyEmail();
    setEmailToast(ok ? 'Email body copied to clipboard.' : 'Could not copy — clipboard blocked.');
    setTimeout(() => setEmailToast(null), 2500);
  }

  return (
    <section className="ms-card">
      <h2 className="ms-title">Export</h2>
      <div className="mt-2 flex flex-wrap gap-2">
        <button
          type="button"
          disabled={disabled}
          onClick={copyEmail}
          className="ms-btn ms-btn-primary ms-btn-xs"
        >
          Copy reply email
        </button>
        <button
          type="button"
          disabled={disabled}
          onClick={onDownloadPdf}
          className="ms-btn ms-btn-secondary ms-btn-xs"
        >
          Download PDF report
        </button>
        <button
          type="button"
          disabled={disabled}
          onClick={onDownloadJson}
          className="ms-btn ms-btn-secondary ms-btn-xs"
        >
          Export JSON
        </button>
      </div>
      {emailToast && (
        <p className="mt-2 text-[11px] text-emerald-700">{emailToast}</p>
      )}
      <p className="mt-2 text-[10px] text-slate-400">
        Paste the email body into Gmail/Outlook. The chief editor receives only what you choose to
        send.
      </p>
    </section>
  );
}
